// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
}
:host a {
  box-shadow: none;
  display: inherit;
  position: relative;
  text-decoration: none;
}
:host mat-icon-button {
  text-align: right;
  text-decoration: none;
}
:host .more-info {
  font-size: 0.9rem;
  text-align: right;
}
:host .span_links {
  cursor: pointer;
  text-decoration: underline;
}

mat-card {
  display: inline-grid;
  flex: auto;
}

.mat-mdc-card:focus,
a:focus {
  outline: none;
}

.node {
  height: auto;
  margin: 20px;
  padding: 0;
}
.node a {
  cursor: pointer;
}
.node a.router-disabled {
  cursor: default;
  pointer-events: none;
}

.general-infos {
  padding-left: 10px;
  padding-top: 10px;
}

.titles {
  display: flex;
  justify-content: flex-start;
  width: 100%;
}
.titles .title {
  flex: 0 0 50%;
  padding-right: 20px;
}
.titles .title h4 {
  font-style: bold;
}
.titles .title span.ref {
  font-style: italic;
}
.titles .mpn {
  flex: 0 0 20%;
  justify-content: flex-start;
  padding-left: 0;
  padding-right: 0;
}
.titles .subtitle {
  display: flex;
  justify-content: flex-end;
  margin-right: 16px;
  width: 100%;
}
.titles .subtitle .mark {
  align-items: center;
  display: flex;
}
.titles .subtitle .mark .version {
  margin-right: 30px;
}

:host(.not-applicable) {
  text-decoration: line-through;
}

:host(.not-applicable.hide-not-applicable) {
  display: none !important;
}

.more {
  justify-self: flex-end;
  padding: 10px;
}

.collapsible-content {
  box-shadow: none !important;
  margin-top: 1.5px;
  max-height: 0;
  overflow: hidden;
  transition: max-height cubic-bezier(0.42, 0, 0.13, 0.97);
}
.collapsible-content.visible {
  max-height: 4000px;
  transition: max-height cubic-bezier(0.42, 0, 0.13, 0.97);
}

.unbold {
  font-weight: normal !important;
}

.row {
  display: flex;
  padding: 10px;
  width: calc(100% - 24px);
}
.row.mpn {
  padding: unset;
}
.row.mobile,
.row .mobile {
  display: none;
}

.basket {
  left: calc(95% - 24px);
  position: relative;
  right: 10px;
}
.basket.collapsed {
  position: absolute;
  top: 50%;
}

.column {
  display: block;
  padding-left: 10px;
  padding-top: 10px;
}

.key {
  font-weight: bold;
  margin-right: 10px;
  min-width: 230px !important;
  width: 20%;
}
.key.mpn-key {
  min-width: 35px !important;
  width: 5%;
}

.values {
  width: 80%;
}

.right {
  text-align: right;
}

@media only screen and (max-width: 800px) {
  .row {
    display: block;
    width: 100%;
  }
  .row .values {
    width: 100%;
  }
  .row.desktop,
  .row .desktop {
    display: none;
  }
  .row.mobile,
  .row .mobile {
    display: block;
  }
  .titles .title {
    flex: 0 0 70%;
    padding-right: 0;
  }
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./apps/viewer/src/app/shared-module/part-card/part-card.component.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;AADF;AAGE;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AADJ;AAIE;EACE,iBAAA;EACA,qBAAA;AAFJ;AAKE;EACE,iBAAA;EACA,iBAAA;AAHJ;AAME;EACE,eAAA;EACA,0BAAA;AAJJ;;AAQA;EACE,oBAAA;EACA,UAAA;AALF;;AAQA;;EAEE,aAAA;AALF;;AAQA;EACE,YAAA;EACA,YAAA;EACA,UAAA;AALF;AAOE;EACE,eAAA;AALJ;AAOI;EACE,eAAA;EACA,oBAAA;AALN;;AAUA;EACE,kBAAA;EACA,iBAAA;AAPF;;AAUA;EACE,aAAA;EACA,2BAAA;EACA,WAAA;AAPF;AASE;EACE,aAAA;EACA,mBAAA;AAPJ;AASI;EACE,gBAAA;AAPN;AAUI;EACE,kBAAA;AARN;AAYE;EACE,aAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;AAVJ;AAaE;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;AAXJ;AAaI;EACE,mBAAA;EACA,aAAA;AAXN;AAaM;EACE,kBAAA;AAXR;;AAiBA;EACE,6BAAA;AAdF;;AAiBA;EACE,wBAAA;AAdF;;AAiBA;EACE,sBAAA;EACA,aAAA;AAdF;;AAiBA;EACE,2BAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,wDAAA;AAdF;AAgBE;EACE,kBAAA;EACA,wDAAA;AAdJ;;AAkBA;EACE,8BAAA;AAfF;;AAkBA;EACE,aAAA;EACA,aAAA;EACA,wBAAA;AAfF;AAiBE;EACE,cAAA;AAfJ;AAkBE;;EAEE,aAAA;AAhBJ;;AAoBA;EACE,sBAAA;EACA,kBAAA;EACA,WAAA;AAjBF;AAmBE;EACE,kBAAA;EACA,QAAA;AAjBJ;;AAqBA;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;AAlBF;;AAqBA;EACE,iBAAA;EACA,kBAAA;EACA,2BAAA;EACA,UAAA;AAlBF;AAoBE;EACE,0BAAA;EACA,SAAA;AAlBJ;;AAsBA;EACE,UAAA;AAnBF;;AAsBA;EACE,iBAAA;AAnBF;;AAuBA;EACE;IACE,cAAA;IACA,WAAA;EApBF;EAsBE;IACE,WAAA;EApBJ;EAuBE;;IAEE,aAAA;EArBJ;EAwBE;;IAEE,cAAA;EAtBJ;EA2BE;IACE,aAAA;IACA,gBAAA;EAzBJ;AACF;AACA,4zLAA4zL","sourcesContent":["@import \"libs/theme/orion-theme\";\n\n:host {\n  display: flex;\n\n  a {\n    box-shadow: none;\n    display: inherit;\n    position: relative;\n    text-decoration: none;\n  }\n\n  mat-icon-button {\n    text-align: right;\n    text-decoration: none;\n  }\n\n  .more-info {\n    font-size: 0.9rem;\n    text-align: right;\n  }\n\n  .span_links {\n    cursor: pointer;\n    text-decoration: underline;\n  }\n}\n\nmat-card {\n  display: inline-grid;\n  flex: auto;\n}\n\n.mat-mdc-card:focus,\na:focus {\n  outline: none;\n}\n\n.node {\n  height: auto;\n  margin: 20px;\n  padding: 0;\n\n  a {\n    cursor: pointer;\n\n    &.router-disabled {\n      cursor: default;\n      pointer-events: none;\n    }\n  }\n}\n\n.general-infos {\n  padding-left: 10px;\n  padding-top: 10px;\n}\n\n.titles {\n  display: flex;\n  justify-content: flex-start;\n  width: 100%;\n\n  .title {\n    flex: 0 0 50%;\n    padding-right: 20px;\n\n    h4 {\n      font-style: bold;\n    }\n\n    span.ref {\n      font-style: italic;\n    }\n  }\n\n  .mpn {\n    flex: 0 0 20%;\n    justify-content: flex-start;\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .subtitle {\n    display: flex;\n    justify-content: flex-end;\n    margin-right: 16px;\n    width: 100%;\n\n    .mark {\n      align-items: center;\n      display: flex;\n\n      .version {\n        margin-right: 30px;\n      }\n    }\n  }\n}\n\n:host(.not-applicable) {\n  text-decoration: line-through;\n}\n\n:host(.not-applicable.hide-not-applicable) {\n  display: none !important;\n}\n\n.more {\n  justify-self: flex-end;\n  padding: 10px;\n}\n\n.collapsible-content {\n  box-shadow: none !important;\n  margin-top: 1.5px;\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height cubic-bezier(0.42, 0, 0.13, 0.97);\n\n  &.visible {\n    max-height: 4000px;\n    transition: max-height cubic-bezier(0.42, 0, 0.13, 0.97);\n  }\n}\n\n.unbold {\n  font-weight: normal !important;\n}\n\n.row {\n  display: flex;\n  padding: 10px;\n  width: calc(100% - 24px);\n\n  &.mpn {\n    padding: unset;\n  }\n\n  &.mobile,\n  .mobile {\n    display: none;\n  }\n}\n\n.basket {\n  left: calc(95% - 24px);\n  position: relative;\n  right: 10px;\n\n  &.collapsed {\n    position: absolute;\n    top: 50%;\n  }\n}\n\n.column {\n  display: block;\n  padding-left: 10px;\n  padding-top: 10px;\n}\n\n.key {\n  font-weight: bold;\n  margin-right: 10px;\n  min-width: 230px !important;\n  width: 20%;\n\n  &.mpn-key {\n    min-width: 35px !important;\n    width: 5%;\n  }\n}\n\n.values {\n  width: 80%;\n}\n\n.right {\n  text-align: right;\n}\n\n// display ipc part for small screen width\n@media only screen and (max-width: 800px) {\n  .row {\n    display: block;\n    width: 100%;\n\n    .values {\n      width: 100%;\n    }\n\n    &.desktop,\n    .desktop {\n      display: none;\n    }\n\n    &.mobile,\n    .mobile {\n      display: block;\n    }\n  }\n\n  .titles {\n    .title {\n      flex: 0 0 70%;\n      padding-right: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
